import CalendarPlaceholder from './calendar-placeholder';

export default CalendarPlaceholder;
